// English strings — the source dictionary. Keys are flat; `{name}` placeholders.
export const en = {
  'app.name': 'Cruzr Fleet',
  'app.tagline': 'Robot operations console',

  'select.search': 'Search…',
  'select.noMatches': 'No matches',
  'screenCtl.toggle': 'Control',
  'screenCtl.toggleTitle': 'Control the robot screen: click = tap, drag = swipe, hold = long press',
  'screenCtl.aria': 'Robot screen — click to tap, drag to swipe, hold for a long press',
  'screenCtl.back': 'Back',
  'screenCtl.home': 'Home',
  'screenCtl.recent': 'Recent apps',
  'screenCtl.keyboard': 'Keyboard',
  'screenCtl.typeText': 'Type text for the robot…',
  'screenCtl.send': 'Send',
  'screenCtl.needsConsent': 'On the robot screen tap “Always allow” and OK to enable remote control.',
  'screenCtl.askAgain': 'Ask again',
  'screenCtl.unavailable': 'Remote control is unavailable: the robot’s ADB (port 5555) is not listening.',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.clear': 'Clear',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.discard': 'Discard',
  'common.dismiss': 'Dismiss',
  'common.download': 'Download',
  'common.dragToReorder': 'Drag to reorder',
  'common.loadFailed': 'Could not load.',
  'common.loading': 'Loading…',
  'common.more': 'More',
  'common.moveUp': 'Move up',
  'common.remove': 'Remove',
  'common.save': 'Save',

  'nav.main': 'Main',
  'nav.fleet': 'Fleet',
  'nav.maps': 'Maps',
  'nav.media': 'Media',
  'nav.drive': 'Drive',
  'nav.agent': 'Agent',
  'nav.logout': 'Sign out',
  'nav.schedule': 'Schedule',
  'nav.autonomy': 'Autonomy',

  'ws.open': 'Live connection',
  'ws.connecting': 'Connecting…',
  'ws.closed': 'Disconnected',
  'ws.reconnecting': 'Live connection lost — reconnecting…',

  'stop.all': 'Stop all',
  'stop.short': 'STOP',
  'stop.allTitle': 'Stop every online robot (drive, navigation, tours, speech)',
  'stop.noneOnline': 'No online robots to stop',

  'toast.okOn': '{what}: ok on {n} robot(s)',
  'toast.partial': '{what}: {ok} ok, {bad} failed — {detail}',

  'time.justNow': 'just now',
  'time.minAgo': '{n} min ago',
  'time.hAgo': '{n} h ago',
  'time.dAgo': '{n} d ago',

  'task.idle': 'Idle',
  'task.estop': 'EMERGENCY STOP',
  'task.tour': 'Tour',
  'task.stepOf': '{step} of {total}',
  'task.charging': 'Charging',
  'task.chargingDock': 'Charging on dock',
  'task.onDock': 'On dock',
  'task.navigating': 'Navigating',
  'task.driving': 'Driving (remote)',
  'task.speaking': 'Speaking',
  'task.listening': 'Listening',

  'login.method': 'Sign-in method',
  'login.tabPassword': 'Password',
  'login.tabToken': 'API token',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.token': 'API token',
  'login.tokenPlaceholder': 'Paste an API token',
  'login.tokenHint': 'Personal API tokens are created on the Agent page. The token stays in this browser only.',
  'login.signIn': 'Sign in',
  'login.signingIn': 'Signing in…',
  'login.badCredentials': 'Wrong username or password.',
  'login.badToken': 'Token rejected.',

  'media.notConfigured': 'Video not configured on the server',
  'media.offline': 'Robot offline',
  'media.idle': '[ not streaming ]',
  'media.error': 'Video error',
  'media.requesting': 'Requesting video…',
  'media.connecting': 'Connecting…',
  'media.connected': 'Waiting for robot video…',
  'media.disconnected': 'Video disconnected',
  'video.live': 'LIVE',

  'talk.talk': 'Talk',
  'talk.talking': 'Talking…',
  'talk.notConnected': '{name}: video/audio is not connected yet',
  'talk.micError': 'Microphone: {msg}',

  'fleet.title': 'Fleet',
  'fleet.count': '{total} robots · {online} online',
  'fleet.filterByGroup': 'Filter by group',
  'fleet.all': 'All',
  'fleet.groupChipTitle': 'Click to filter · double-click to edit',
  'fleet.editGroup': 'Edit group',
  'fleet.addGroup': '+ Group',
  'fleet.empty': 'No robots yet. Start the robot app (or the fake robot).',
  'fleet.emptyGroup': 'No robots in this group.',
  'fleet.offlineSeen': 'Offline · last seen {ago}',
  'fleet.hear': 'Hear {name} surroundings',
  'fleet.soundOn': 'Sound on',
  'fleet.muted': 'Muted',
  'fleet.select': 'Select {name}',
  'fleet.talkThrough': 'Talk through {name} speaker',
  'fleet.goToCharger': 'Go to charger',
  'fleet.chargeShort': 'Charge',
  'fleet.onCharger': 'On charger',
  'fleet.leaveCharger': 'Leave charger',
  'fleet.cancelCharger': 'Cancel · going to charger',
  'fleet.control': 'Control',
  'fleet.bulkLabel': 'Actions for selected robots',
  'fleet.selected': '{n} selected',
  'fleet.sayToSelected': 'Say to selected',
  'fleet.sayPlaceholder': 'Say something through all selected robots…',
  'fleet.say': 'Say',
  'fleet.runTour': 'Run tour…',
  'fleet.dance': 'Dance…',
  'fleet.danceWhat': 'Dance {id}',
  'fleet.talkToSelected': 'Talk to selected',
  'fleet.talkingTo': 'Talking to {n} robots… tap to stop',
  'fleet.clearSelection': 'Clear',
  'fleet.stopSelected': 'Stop selected',
  'fleet.noneOnlineSelected': 'None of the selected robots is online',
  'fleet.noMapForTours': 'The selected robots have no known map with tours.',
  'fleet.noTours': 'No tours for the selected robots’ maps.',
  'fleet.tourWhat': 'Tour “{name}”',
  'fleet.tourStarted': 'Tour “{name}” started',
  'fleet.editGroupTitle': 'Edit group',
  'fleet.newGroupTitle': 'New group',
  'fleet.groupName': 'Group name',
  'fleet.members': 'Members',
  'fleet.groupSaved': 'Group “{name}” saved',
  'fleet.deleteGroupConfirm': 'Delete group “{name}”?',

  'robot.unknown': 'Unknown robot.',
  'robot.online': 'Online',
  'robot.offline': 'offline',
  'robot.offlineSeen': 'Offline · last seen {ago}',
  'robot.charging': 'Charging',
  'robot.phoneDrive': 'Phone drive',
  'robot.liveVideo': 'Live video',
  'robot.liveWatching': 'LIVE · {n} watching',
  'robot.headCamera': '[ head camera · live ]',
  'robot.positionOnMap': 'Position on map',
  'robot.talkingMute': 'Talking… tap to mute',
  'robot.snapshot': 'Snapshot',
  'robot.snapping': 'Taking…',
  'robot.robotSound': 'Robot sound',
  'robot.volume': 'Robot sound volume',
  'robot.mute': 'Mute robot sound',
  'robot.unmute': 'Unmute robot sound',
  'robot.enableAudio': 'Click to enable audio',
  'robot.events': 'Events',
  'robot.noEvents': 'No events yet.',
  'robot.controls': 'Controls',
  'robot.dock': 'Dock & charge',
  'robot.rename': 'Rename',
  'robot.renamePrompt': 'Display name (empty = the robot’s own name)',
  'robot.tours': 'Assigned tours',
  'robot.noTours': 'No tours assigned to this robot.',

  'drive.title': 'Drive',
  'drive.keysHint': 'W A S D / arrows · W+D = smooth turn',
  'drive.fwdLeftAria': 'Forward and left (arc)',
  'drive.fwdRightAria': 'Forward and right (arc)',
  'drive.backLeftAria': 'Back and left (arc)',
  'drive.backRightAria': 'Back and right (arc)',
  'drive.fwdAria': 'Forward (W)',
  'drive.backAria': 'Backward (S)',
  'drive.leftAria': 'Turn left (A)',
  'drive.rightAria': 'Turn right (D)',
  'drive.stop': 'STOP',
  'drive.speed': 'Speed',
  'drive.maxSpeed': '1.0 max',
  'drive.turn': 'Turn',
  'drive.forward': 'forward',
  'drive.backward': 'backward',
  'drive.turnLeft': 'turning left',
  'drive.turnRight': 'turning right',
  'drive.driving': 'Driving {dir} · {v} m/s · {w} °/s · auto-stop after 400 ms without input',
  'drive.idle': 'Idle · hold a key or button to drive · Space/Esc = stop',
  'drive.offline': 'Robot offline',

  'speech.title': 'Speech',
  'speech.language': 'Language',
  'speech.searchVoices': 'Search voices',
  'speech.otherLanguages': 'Other languages',
  'speech.noVoices': 'No voices found',
  'speech.defaultHint': 'Server default for this language',
  'speech.previewVoice': 'Preview voice {name}',
  'speech.voice': 'Voice',
  'speech.defaultVoice': 'default voice',
  'speech.defaultVoiceNamed': 'default ({name})',
  'speech.voicesUnavailable': 'Voice list unavailable (TTS not configured?)',
  'speech.textToSay': 'Text to say',
  'speech.placeholder': 'Type what the robot should say',
  'speech.say': 'Say',
  'speech.saidVia': 'said via {engine} TTS',
  'speech.listen': 'Listen',
  'speech.listening': 'Listening…',
  'speech.heard': 'Heard',
  'speech.listenHint': 'Listen records from the robot microphone and transcribes it.',

  'volume.label': 'Volume',
  'volume.speaker': 'Speaker volume',
  'volume.voice': 'voice {n}%',
  'volume.mute': 'Mute',
  'volume.unmute': 'Unmute',
  'volume.unknown': 'The robot has not reported its volume yet.',
  'volume.bulk': 'Volume…',
  'volume.apply': 'Set',
  'volume.what': 'Volume {n}%',
  'head.title': 'Head',
  'head.upDown': 'up ↔ down',
  'head.up': 'up',
  'head.down': 'down',
  'head.angle': 'Head angle',
  'head.preset': 'Head preset',
  'head.customAngle': 'Angle…',
  'head.rangeHint': '° (180 up … 270 down)',
  'head.p.adult': 'Adult',
  'head.p.teen': 'Teen',
  'head.p.child': 'Child',
  'head.p.straight': 'Straight',
  'head.p.down': 'Down',
  'head.hint': 'Cruzr can only tilt the head; turn the body with A/D.',
  'quick.title': 'Quick actions',
  'quick.motion': 'Motion',
  'quick.emotion': 'Emotion',
  'quick.dance': 'Dance',
  'quick.light': 'Light',
  'quick.lightEffect': 'Light effect',
  'quick.noEffect': 'no effect',
  'quick.play': 'Play',
  'quick.show': 'Show',
  'quick.dismiss': 'Dismiss emotion',
  'quick.on': 'On',
  'quick.off': 'Off',
  'motion.wave': 'Wave',
  'motion.nod': 'Nod',
  'motion.applause': 'Applause',
  'motion.guideLeft': 'Guide left',
  'motion.guideRight': 'Guide right',
  'motion.hug': 'Hug',

  'phone.holdToTalk': 'Hold to talk',
  'phone.talking': 'Talking…',
  'phone.joystick': 'Drive joystick',
  'phone.forward': 'FORWARD',
  'phone.back': 'BACK',
  'phone.left': 'LEFT',
  'phone.right': 'RIGHT',
  'phone.maxSpeed': 'Max speed',
  'phone.say': 'Say…',
  'phone.sayTitle': 'Say through the robot',

  'maps.title': 'Maps',
  'maps.none': 'No maps on the server yet. Upload a robot map archive or pull one from a robot.',
  'maps.map': 'Map',
  'maps.tool': 'Tool',
  'maps.toolPan': 'Pan',
  'maps.toolGo': 'Click to go',
  'maps.toolAdd': 'Add point',
  'maps.toolWalls': 'Walls',
  'maps.leaveConfirm': 'You have unsaved changes on this map (points or walls). Leave anyway?',
  'maps.upload': 'Upload map',
  'maps.pull': 'Pull from robot',
  'maps.delete': 'Delete map',
  'maps.deleteConfirm': 'Delete map “{name}” from the server? (Robots keep their copy.)',
  'maps.deploy': 'Deploy to robots',
  'maps.viewport': 'Map viewport',
  'maps.imageAlt': 'Occupancy map {name}',
  'maps.layers': 'Layers',
  'maps.layerRobots': 'Robots',
  'maps.layerPoints': 'Points',
  'maps.layerPaths': 'Planned paths',
  'maps.layerWalls': 'Virtual walls',
  'maps.layerGrid': 'Grid 1 m',
  'maps.zoom': 'Zoom',
  'maps.zoomIn': 'Zoom in',
  'maps.zoomOut': 'Zoom out',
  'maps.fit': 'Fit map',
  'maps.follow': 'Follow selected robot',
  'maps.minimap': 'Minimap',
  'maps.cursor': 'cursor x {x} · y {y}',
  'maps.pointAria': 'Point {name}',
  'maps.locationActions': 'Location actions',
  'maps.sendHere': 'Send {name} here',
  'maps.addPointHere': 'Add point here',
  'maps.setPose': 'Set robot pose (relocalize)',
  'maps.poseHeadingPrompt': 'Robot heading at this spot (degrees, 0 = +x, counter-clockwise)',
  'maps.noRobot': 'No online robot to send',
  'maps.noRobotOnline': 'no robots online',
  'maps.otherMap': 'other map',
  'maps.panel': 'Map panel',
  'maps.points': 'Points',
  'maps.pointsCount': '{n} on this map',
  'maps.searchPoints': 'Search points',
  'maps.actionsN': '{n} actions',
  'maps.noPoints': 'No points yet — use “Add point” and click the map.',
  'maps.newPointName': 'Point {n}',
  'maps.rename': 'Rename',
  'maps.heading': 'heading',
  'maps.onArrival': 'On arrival',
  'maps.addAction': '+ Add action',
  'maps.noActions': 'No actions — the robot just arrives.',
  'maps.robot': 'Robot',
  'maps.goRun': 'Go & run actions',
  'maps.goOnly': 'Go only',
  'maps.goUnsaved': 'The point has unsaved changes. Save now? (Deploy/sync points so the robot gets them.)',
  'maps.syncHint': 'Saved. Use “Deploy to robots → Sync points” so robots get the new points.',
  'maps.pathInfo': 'Straight-line distance {m} m · about {s} s at 0.4 m/s',
  'maps.deletePoint': 'Delete point',
  'maps.deletePointConfirm': 'Delete point “{name}”?',
  'maps.selectHint': 'Select a point in the list or on the map. Drag a pin to move it. Use “Add point” to create points, “Click to go” to send a robot anywhere.',
  'maps.saveDirty': 'Save points *',
  'maps.saved': 'Points saved',
  'maps.saving': 'Saving…',
  'maps.pointsSaved': 'Points saved',
  'maps.saveFailed': 'Save failed',
  'maps.discardConfirm': 'Discard unsaved point changes?',
  'maps.langDefault': 'default',
  'maps.sayPlaceholder': 'Text to say',
  'maps.mediaPick': 'Media file',
  'maps.pickMedia': '— pick from library —',
  'maps.legacyMedia': 'legacy path: {path}',
  'maps.seconds': 'Seconds',
  'maps.degrees': 'Degrees',
  'maps.turnHint': '° (+ = left)',
  'maps.dismissEmotion': '(dismiss)',
  'maps.stopOnError': 'stop on error',
  'maps.stopOnErrorTitle': 'Skip the remaining actions if this one fails',
  'maps.uploadTitle': 'Upload map archive',
  'maps.uploadHint': 'The .tar.gz archive of a robot map folder (/sdcard/UBT_Map/<name>/). Uploading a map with an existing name keeps its id and points.',
  'maps.archive': 'Archive',
  'maps.nameOptional': 'Name (optional)',
  'maps.namePlaceholder': 'from the archive folder',
  'maps.uploaded': 'Map “{name}” uploaded',
  'maps.uploadFailed': 'Upload failed',
  'maps.pullTitle': 'Pull a map from a robot',
  'maps.listMaps': 'List maps',
  'maps.robotMap': 'Map on the robot',
  'maps.current': 'current',
  'maps.robotNoMaps': 'The robot reported no maps.',
  'maps.pulling': 'Pulling…',
  'maps.pulled': 'Pulled “{name}”',
  'maps.pullFailed': 'Pull failed',
  'maps.deployTitle': 'Deploy “{name}”',
  'maps.deployHint': 'Deploy installs the whole map pack (and media used by point actions) on the robots. Sync points only re-sends points.json.',
  'maps.deploySavesFirst': 'Unsaved points will be saved first.',
  'maps.targetRobots': 'Robots',
  'maps.targetGroup': 'Group',
  'maps.pickGroup': '— pick a group —',
  'maps.setCurrent': 'Make it the current map on the robots',
  'maps.syncPoints': 'Sync points only',
  'maps.deploying': 'Deploying…',
  'maps.deployWhat': 'Deploy {name}',
  'maps.syncWhat': 'Sync points',

  'walls.title': 'Walls',
  'walls.modified': 'Modified from original',
  'walls.needsDeploy': 'Needs deploy: {list}',
  'walls.help': 'Virtual walls are lines the robot will never cross when it navigates — use them for glass doors, stairs, cables or areas guests use. They are stored in the map; robots get them when you deploy the map.',
  'walls.count': '{n} on this map',
  'walls.revision': 'rev {n}',
  'walls.draw': '+ Draw a wall',
  'walls.drawingHint': 'Stop drawing',
  'walls.item': 'Wall {n}',
  'walls.vertices': '{n} pts',
  'walls.deleteItem': 'Delete wall {n}',
  'walls.none': 'No virtual walls on this map.',
  'walls.keys': 'Click to place points · double-click or Enter to finish · Backspace removes the last point · Esc cancels · Shift locks 0/45/90° · ends snap to other walls · Ctrl/⌘+Z undo · Ctrl+Y or ⌘+Shift+Z redo. Click a wall to select it; drag its points to move them.',
  'walls.undoEdit': 'Undo',
  'walls.redoEdit': 'Redo',
  'walls.apiMissing': 'Wall editing is not available on this server yet (PROTOCOL §6.1 endpoints missing). Your edits are kept here until you leave the page.',
  'walls.savedNotice': 'Walls saved — deploy to robots to apply',
  'walls.outdated': 'Robots with the old walls: {list}.',
  'walls.noOutdated': 'No robot has this map installed yet.',
  'walls.reset': 'Reset to original walls',
  'walls.resetConfirm': 'Replace all walls with the ones from the original map archive? Unsaved edits are lost.',
  'walls.resetDone': 'Walls reset to the original',
  'walls.resetFailed': 'Reset failed',
  'walls.saveDirty': 'Save walls *',
  'walls.saved': 'Walls saved',
  'walls.saving': 'Saving…',
  'walls.saveFailed': 'Saving walls failed',
  'walls.saveBeforeDeploy': 'Walls have unsaved changes. Save them before deploying?',
  'walls.addVertex': 'Add vertex',
  'walls.addVertexActive': 'Click a segment…',
  'walls.done': 'Done',
  'walls.dragVertex': 'Drag to move',
  'walls.drawBarHint': 'Double-click / Enter to finish',
  'walls.undo': 'Undo point',
  'walls.finish': 'Finish',

  // §6.2 real walls: pencil / eraser on the scanned occupancy grid
  'scan.modeAria': 'Which walls',
  'scan.modeVirtual': 'Virtual · {n}',
  'scan.modeScan': 'Real (scan)',
  'scan.title': 'Real walls',
  'scan.revision': 'version {n}',
  'scan.editedByHand': 'edited by hand',
  'scan.originalScan': 'original scan',
  'scan.modifiedTag': 'Scan edited by hand',
  'scan.help': 'The robot plans its path on the scanned map.',
  'scan.helpPencil': 'With the {b}, draw what the laser cannot see: glass, openings, railings.',
  'scan.helpPencilB': 'pencil',
  'scan.helpEraser': 'With the {b}, wipe scan debris: people, chairs, boxes.',
  'scan.helpEraserB': 'eraser',
  'scan.warn': 'Do not erase real walls: the robot uses them to know where it is. The laser cannot see a drawn wall — it only blocks the path.',
  'scan.hand': 'Hand',
  'scan.pencil': 'Pencil',
  'scan.pencilSub': 'Draw a wall',
  'scan.eraser': 'Eraser',
  'scan.eraserSub': 'Wipe debris',
  'scan.toolbar': 'Scan editing tools',
  'scan.width': 'Width',
  'scan.cm': '{n} cm',
  'scan.m': '{n} m',
  'scan.undo': 'Undo',
  'scan.redo': 'Redo',
  'scan.original': 'Original scan',
  'scan.originalTitle': 'Show the original scan without edits',
  'scan.originalPill': 'Original scan · edits hidden',
  'scan.originalFailed': 'Original scan is not available',
  'scan.showOriginal': 'Show the original scan (no edits)',
  'scan.hintPencil': 'Pencil: drag on the map to draw a wall · Shift — straight line · Ctrl/⌘+Z — undo · wheel — zoom',
  'scan.hintEraser': 'Eraser: drag to wipe scan obstacles (people, chairs, boxes) · Ctrl/⌘+Z — undo · wheel — zoom',
  'scan.hintPan': 'Hand: drag the map, wheel — zoom · hold Space for the hand in any tool',
  'scan.legend': 'Legend',
  'scan.legendWall': 'New wall · not saved',
  'scan.legendErase': 'Erased · not saved',
  'scan.legendVirtual': 'Virtual wall (not edited here)',
  'scan.pending': 'Unsaved edits: {n}',
  'scan.statWall': '+ {m} m of wall',
  'scan.statErase': 'erased {m} m²',
  'scan.reset': 'Restore the original scan',
  'scan.resetHelp': 'Deletes all saved scan edits of this map. Virtual walls and points are not touched.',
  'scan.resetConfirm': 'Restore the original scan? All saved scan edits of this map will be deleted. Virtual walls and points stay as they are.',
  'scan.resetConfirmPending': 'Unsaved edits ({n}) will be lost too.',
  'scan.resetDone': 'Original scan restored',
  'scan.resetFailed': 'Restoring the original scan failed',
  'scan.save': 'Save map *',
  'scan.saving': 'Saving…',
  'scan.noChanges': 'No changes',
  'scan.savedButton': 'Map saved',
  'scan.savedNotice': 'Map saved · version {n}',
  'scan.outdatedOne': '{name} still drives on the old version. Deploy the map so the robot gets the edits.',
  'scan.outdatedMany': '{list} still drive on the old version. Deploy the map so the robots get the edits.',
  'scan.noOutdated': 'No robot has this map installed yet.',
  'scan.deploy': 'Deploy to robots',
  'scan.dismiss': 'Hide',
  'scan.savedToast': 'Map saved — deploy it to robots to apply the edits',
  'scan.saveFailed': 'Saving the map failed',
  'scan.saveError': 'Could not save the map: {reason}. Your edits are still on screen — try again.',
  'scan.noResponse': 'the server did not respond',
  'scan.apiMissing': 'Scan editing is not available on this server yet (PROTOCOL §6.2 endpoints missing). Your edits stay here until you leave the page.',
  'scan.limit': 'Too many scan edits on this map: at most {strokes} strokes and {coords} coordinates in total.',
  'scan.switchConfirm': 'Unsaved scan edits ({n}) will be lost. Switch anyway?',
  'scan.saveBeforeDeploy': 'The scan has unsaved edits. Save them before deploying?',

  // §6.3 "what blocks the way": why points are unreachable
  'access.tab': 'Reachability',
  'access.badge': '{n} unreachable',
  'access.heading.one': '{n} point is unreachable',
  'access.heading.few': '{n} points are unreachable',
  'access.heading.many': '{n} points are unreachable',
  'access.allOk': 'All points are reachable',
  'access.help': 'The robot needs a passage at least {w} m wide: {c} m from the walls on each side. Below is what blocks the way, starting with what blocks the most.',
  'access.showOnMap': 'Show on the map',
  'access.chip': 'What blocks the way',
  'access.narrow': 'Narrow passage',
  'access.narrowAt': 'Narrow passage near “{name}”',
  'access.narrowZone': 'Narrow passage into “{name}”',
  'access.narrowTo': 'Narrow passage to “{name}”',
  'access.narrowToMore': 'Narrow passage to “{name}” and {n} more',
  'access.realTo': 'Scan wall on the way to “{name}”',
  'access.realToMore': 'Scan wall on the way to “{name}” and {n} more',
  'access.virtual': 'Virtual wall #{n}',
  'access.real': 'Scan wall',
  'access.realAt': 'Scan wall near “{name}”',
  'access.blocks.one': 'blocks {n} point',
  'access.blocks.few': 'blocks {n} points',
  'access.blocks.many': 'blocks {n} points',
  'access.passage': 'passage ≈ {w} m',
  'access.kindVirtual': 'virtual wall',
  'access.kindReal': 'scan wall',
  'access.helpNarrow': 'There is less than {w} m between the scan walls. If scan debris (people, chairs) is in the passage, erase it. If the passage is real, the robot cannot drive through.',
  'access.helpVirtual': 'The robot never crosses virtual walls. Remove or move this one if robots may drive here.',
  'access.helpReal': 'A wall of the scan closes the way. If it is not a real wall (a door closed during the scan, debris), erase it.',
  'access.pointsList': 'Points: {list}',
  'access.show': 'Show on map',
  'access.fixErase': 'Open the eraser here',
  'access.fixWall': 'Edit the wall',
  'access.computing': 'Computing…',
  'access.noBlockers': 'The server could not tell what exactly blocks them.',
  'access.apiMissing': 'This server cannot find what blocks the way yet (PROTOCOL §6.3 endpoint missing). Unreachable points are still marked on the map.',
  'access.loadFailed': 'Could not load the blockers: {msg}',
  'access.markerVirtual': '#{k} · {n}',
  'access.markerReal': 'Scan wall · {n}',
  'access.passageVV': 'passage ≈ {w} m between virtual walls #{a} and #{b}',
  'access.passageRV': 'passage ≈ {w} m between a scan wall and virtual wall #{a}',
  'access.passageV1': 'passage ≈ {w} m between parts of virtual wall #{a}',
  'access.passageRR': 'passage ≈ {w} m between scan walls',
  'access.fixWallN': 'Edit wall #{n}',
  'access.helpNarrowVirtual': 'Move these walls apart so the passage is at least {w} m wide.',
  'access.helpNarrowOneWall': 'Reshape virtual wall #{n} so the passage is at least {w} m wide.',
  'access.helpNarrowMixed': 'Move virtual wall #{n} away from the scan wall so the passage is at least {w} m wide. If the scan wall is debris (people, chairs), erase it.',
  'access.legend': 'Legend',
  'access.legendNarrow': 'Narrow passage: under {w} m',
  'access.legendWall': 'Virtual wall in the way',
  'access.legendPath': 'Where the robot cannot pass',
  'access.legendPoint': 'Unreachable point',

  'loc.title': 'Localization',
  'loc.located': 'located',
  'loc.locating': 'locating…',
  'loc.blockedCharging': 'blocked: robot is charging',
  'loc.leaveCharger': 'Leave charger',
  'loc.offChargerFirst': 'Take {name} off the charger first — it cannot localize while charging.',
  'loc.auto': 'Locate automatically',
  'loc.autoTitle': 'Ask the robot to find its position on the current map by itself (no hint)',
  'loc.autoLocate': 'Auto-locate',
  'loc.autoLocateTitle': 'The robot localizes by itself after start, map change and leaving the charger',
  'loc.setPoseOnMap': 'Set pose on map…',
  'loc.olderApp': 'The robot app does not report localization details.',
  'mapRobots.title': 'Robots and their maps',
  'mapRobots.notLocated': 'not located',
  'mapRobots.setPose': 'Set pose',
  'mapRobots.onMap': 'is on map {name}',
  'mapRobots.open': 'Open',
  'mapRobots.noMap': 'no map loaded',
  'mapRobots.hint': 'Click where {name} stands, then choose “Set robot pose”.',
  'mapRobots.located': '{name} located',
  'mapRobots.mapNotOnServer': 'Map “{name}” is not on the server — pull it from the robot first.',
  'mapRobots.noMapLoaded': 'The robot has no map loaded.',
  'tours.title': 'Tours',
  'tours.apiMissing': 'Tours are not available on this server yet (PROTOCOL §13 endpoints missing).',
  'tours.stopsN': '{n} stops',
  'tours.loop': 'loop',
  'tours.endsDock': 'ends at charger',
  'tours.stays': 'stays',
  'tours.returns': 'returns',
  'tours.robotsN': '{n} robots',
  'tours.notAssigned': 'not assigned',
  'tours.new': '+ New tour',
  'tours.newName': 'New tour',
  'tours.name': 'Tour name',
  'maps.resizePanel': 'Drag to resize the panel (double-click resets)',
  'tours.description': 'Description (shown on the robot\'s tour card)',
  'tours.descriptionPh': 'What visitors will see on this tour',
  'tours.atEnd': 'At the end',
  'tours.endDock': 'Go to charger',
  'tours.endStay': 'Stay at last stop',
  'tours.endReturn': 'Return to {name}',
  'tours.loopLabel': 'Loop the tour until stopped',
  'tours.stopsHeader': 'Stops · drag to reorder',
  'tours.noActions': 'no actions',
  'tours.skipActions': 'actions skipped',
  'tours.missingPoint': 'point missing',
  'tours.runActions': 'run actions',
  'tours.wait': 'wait',
  'tours.removeStop': 'Remove stop {name}',
  'tours.addStop': '+ Add stop from points',
  'tours.noPoints': 'Add points on the map first',
  'tours.assigned': 'Assigned robots',
  'tours.noMap': 'no map',
  'tours.delete': 'Delete tour',
  'tours.deleteConfirm': 'Delete tour “{name}”?',
  'tours.discardConfirm': 'Discard unsaved tour changes?',
  'tours.saveDirty': 'Save tour *',
  'tours.saved2': 'Saved',
  'tours.saved': 'Tour “{name}” saved',
  'tours.saveFailed': 'Saving the tour failed',
  'tours.nameRequired': 'The tour needs a name',
  'tours.runAssigned': 'Run on assigned now',
  'tours.noAssigned': 'Assign robots to the tour first',
  'tours.run': 'Run',
  'tours.none': 'No tours on this map yet.',
  'tours.pickHint': 'Pick a tour to edit.',
  'tours.routeInfo': '{n} stops · {m} m (straight lines)',

  'media.title': 'Media',
  'media.upload': 'Upload',
  'media.apiMissing': 'The media library is not available on this server (PROTOCOL §12 endpoints missing).',
  'media.libraryUnavailable': 'media library unavailable',
  'media.dropHint': 'Drop video, audio, images or PPTX / PDF here',
  'media.dropLimit': 'up to 1 GB per file',
  'media.all': 'All',
  'media.presentations': 'Presentations',
  'media.video': 'Video',
  'media.audio': 'Audio',
  'media.images': 'Images',
  'media.empty': 'Nothing uploaded yet.',
  'media.details': 'Media details',
  'media.pickHint': 'Select a file to preview it, or drop files on the left to upload.',
  'media.uploaded': 'Uploaded {name}',
  'media.converting': 'converting…',
  'media.convertingLong': 'Converting the presentation to slides…',
  'media.convertError': 'conversion failed',
  'media.generating': 'generating…',
  'media.langsReady': '{langs} ready',
  'media.noNarration': 'no narration',
  'media.pagesN': '{n} pages',
  'media.slidesN': '{n} slides',
  'media.renamePrompt': 'New name',
  'media.deleteConfirm': 'Delete “{name}”?',
  'media.usedBy': 'Used by point actions on map(s): {maps}.',
  'media.playOnRobot': 'Play on robot…',
  'media.targets': 'Robots',
  'media.narrationLang': 'Narration language',
  'media.silent': 'silent',
  'media.play': 'Play',
  'media.playWhat': 'Play {name}',
  'media.slideN': 'slide {n}',
  'media.none': 'none',
  'media.narrationInfo': 'Narration: {source} · voice {voice} · {dur} · {status}',
  'media.byClaude': 'generated by the LLM',
  'media.custom': 'custom text',
  'media.nstatus.pending': 'queued',
  'media.nstatus.generating': 'generating…',
  'media.nstatus.ready': 'saved',
  'media.nstatus.error': 'error',
  'media.noNarrationLang': 'No narration in this language yet.',
  'media.generate': 'Generate…',
  'media.regenerate': 'Regenerate…',
  'media.ownText': 'Use my own text',
  'media.playAll': 'Play full narration',
  'media.stopPlayback': 'Stop',
  'media.deleteNarration': 'Delete narration',
  'media.deleteNarrationConfirm': 'Delete the {lang} narration?',
  'media.generatingLong': 'The LLM is writing the narration and the TTS is synthesizing it. This page updates automatically.',
  'media.playSegment': 'Play segment {n}',
  'media.edit': 'Edit',
  'media.generateTitle': 'Generate narration ({lang})',
  'media.regenerateTitle': 'Regenerate narration ({lang})',
  'media.instructions': 'Instructions for the LLM (optional)',
  'media.instructionsPlaceholder': 'e.g. Shorter, friendly, for school groups',
  'media.replacesSaved': 'Replaces the saved text and audio',
  'media.generateBtn': 'Generate',
  'media.generationStarted': 'Narration generation started',
  'media.ownTextTitle': 'Use my own text',
  'media.wholeText': 'Whole text',
  'media.perSlide': 'Per slide',
  'media.wholeHint': 'One text for the whole deck — slides advance evenly over the audio.',
  'media.synthesize': 'Synthesize',
  'media.customStarted': 'Synthesizing your text',
  'media.editSegment': 'Edit segment {n}',
  'media.saveResynth': 'Save & re-synthesize',
  'media.segmentSaved': 'Segment updated',

  'agent.title': 'Agent',
  'agent.subtitle': 'The LLM (GLM / Qwen) controls the selected robots with fleet tools',
  'agent.disabled': 'The built-in agent is disabled on the server (no Anthropic API key). The MCP endpoint still works.',
  'agent.empty': 'Tell the robots what to do. Tool calls, results and camera snapshots stream here.',
  'agent.working': 'Working…',
  'agent.running': 'running…',
  'agent.image': 'image',
  'agent.done': 'Done ({n} steps).',
  'agent.recentRuns': 'Recent runs',
  'agent.noRuns': 'No runs yet.',
  'agent.state.running': 'running',
  'agent.state.done': 'done',
  'agent.state.error': 'error',
  'agent.state.cancelled': 'cancelled',
  'agent.mcpNote1': 'Same tools are available over MCP at',
  'agent.mcpNote2': 'for Claude Code or Claude Desktop (use an API token).',
  'agent.prompt': 'Prompt',
  'agent.placeholder': 'Tell the robots what to do…  (Ctrl/⌘+Enter to run)',
  'agent.targets': 'Targets',
  'agent.groupTag': 'Group: {name}',
  'agent.addTarget': '+ Add',
  'agent.noTargets': 'none — the agent picks robots itself',
  'agent.stopRun': 'Stop run',
  'agent.run': 'Run',

  'sessions.activeAria': 'Active sessions',
  'sessions.new': '+ New session',
  'sessions.newTitle': 'New agent session',
  'sessions.titleLabel': 'Title',
  'sessions.titlePlaceholder': 'e.g. Museum morning',
  'sessions.robots': 'Robots',
  'sessions.groupOptional': 'Group (optional)',
  'sessions.create': 'Create session',
  'sessions.all': 'All sessions · {n}',
  'sessions.none': 'No sessions yet.',
  'sessions.noneActive': 'No active sessions. Start one for a set of robots.',
  'sessions.open': 'Open',
  'sessions.reopen': 'Reopen',
  'sessions.deleteConfirm': 'Delete session “{title}” and its history?',
  'sessions.apiMissing': 'Agent sessions are not available on this server yet — running single prompts (no conversation memory).',
  'sessions.quick': 'Quick run',
  'sessions.robotsN': '{n} robots',
  'sessions.state.idle': 'Idle',
  'sessions.state.running': 'Running',
  'sessions.state.closed': 'Closed',
  'sessions.close': 'Close session',
  'sessions.renamePrompt': 'Session title',
  'sessions.renameHint': 'Double-click to rename',
  'sessions.conversation': 'Conversation',
  'sessions.working': 'Working… other sessions keep running in the background',
  'sessions.messageAria': 'Message to this session',
  'sessions.placeholder': 'Continue this session… (Ctrl/⌘+Enter)',
  'sessions.robotsIn': 'Robots in session',
  'sessions.alsoIn': 'also in {list}',
  'sessions.conflictTitle': 'This robot is also targeted by another active session — commands are not locked.',
  'sessions.addRobots': '+ Add',
  'sessions.allAdded': 'All robots are in this session.',
  'sessions.stop': 'Stop session',
  'sessions.stopTitle': 'Cancel the current run and send stop to this session’s robots',
  'sessions.send': 'Send',
  'sessions.badgeDone': 'finished in the background',
  'sessions.badgeError': 'failed in the background',
  'sessions.liveAria': 'Live robots in this session',
  'sessions.live': 'Live · {n} robots',
  'sessions.source': 'Video source',
  'sessions.camera': 'Camera',
  'sessions.screen': 'Screen',
  'sessions.noRobots': 'No robots in this session.',
  'sessions.openControl': 'Open control →',
  'sessions.consentNote': 'The screen stream needs a one-time “Start now” tap on the robot’s display (Android screen-capture consent).',
  'media.needsConsent': 'Waiting for consent on the robot screen',
  'media.waitingScreen': 'Waiting for the robot screen…',
  'media.retryIn': 'Retrying in {n} s',
  'media.noFrames': 'Connected, but no picture arrives from the robot (static screen — waiting for a key frame)',
  'day.mon': 'Mon',
  'day.tue': 'Tue',
  'day.wed': 'Wed',
  'day.thu': 'Thu',
  'day.fri': 'Fri',
  'day.sat': 'Sat',
  'day.sun': 'Sun',

  'know.title': 'Knowledge — what to tell here',
  'know.badge': 'knowledge',
  'know.badgeTitle': 'This point has a description the robot and the agent use as facts',
  'know.langTabs': 'Description language',
  'know.base': 'Main',
  'know.description': 'Description (the only facts the robot may tell here)',
  'know.descriptionPh': 'What is here, facts to tell visitors, names, dates… The agent must not invent anything beyond this.',
  'know.override': 'Description in {lang} (overrides the main one for this language)',
  'know.overridePh': 'Optional — leave empty to translate the main description',
  'know.talkingPoints': 'Talking points',
  'know.addTalkingPoint': '+ Add',
  'know.talkingPointPh': 'One short point to mention',
  'know.talkingPointN': 'Talking point {n}',
  'know.noTalkingPoints': 'No talking points.',
  'know.duration': 'Duration hint',
  'know.seconds': 's',
  'know.attachments': 'Attachments (used as knowledge)',
  'know.addAttachment': 'Add from media library…',
  'know.attachmentsHint': 'PDF, presentations, text and images — the server extracts their text for the agent.',

  'tours.repeat': 'Repeat',
  'tours.repeat.once': 'Once',
  'tours.repeat.rounds': 'Rounds',
  'tours.repeat.until': 'Until time',
  'tours.repeat.loop': 'Loop',
  'tours.rounds': 'Rounds',
  'tours.until': 'Until',
  'tours.pause': 'Pause',
  'tours.minutes': 'min between rounds',
  'tours.roundsN': '{n} rounds',
  'tours.untilT': 'until {time}',
  'tours.agentCreated': 'agent-created',
  'tours.agentCreatedHint': 'Built by the agent (run {run}). You can edit it like any other tour.',
  'tours.stopExtras': 'Say & actions',
  'tours.sayHere': 'Say at this stop',
  'tours.sayHerePh': 'Optional text the robot says after the point’s own actions',
  'tours.extraActions': 'Extra actions (this tour only)',

  'sched.title': 'Schedule',
  'sched.tz': 'Time zone: {tz}',
  'sched.tzBrowser': 'Your browser is in {tz}; schedule times use the server time zone.',
  'sched.tzTitle': 'Times are in the server time zone',
  'sched.view': 'View',
  'sched.viewDetails': 'Details',
  'sched.viewWeek': 'Week',
  'sched.new': '+ New schedule',
  'sched.list': 'Schedules',
  'sched.apiMissing': 'Schedules are not available on this server yet (PROTOCOL §18 endpoints missing).',
  'sched.none': 'No schedules yet.',
  'sched.pickHint': 'Pick a schedule or create a new one.',
  'sched.everyDay': 'every day',
  'sched.tourRounds': 'tour × {n}',
  'sched.tourRepeat': 'tour until the window ends',
  'sched.autonomyWith': 'autonomy: {name}',
  'sched.agentRun': 'agent prompt',
  'sched.next': 'Next:',
  'sched.last': 'last run',
  'sched.disabled': 'disabled',
  'sched.enable': 'Enable',
  'sched.disable': 'Disable',
  'sched.enabledFor': 'Enabled: {name}',
  'sched.now': 'now',
  'sched.inMin': 'in {n} min',
  'sched.inH': 'in {h} h {m} min',
  'sched.name': 'Name',
  'sched.namePh': 'e.g. Exhibition afternoons',
  'sched.targets': 'Robots',
  'sched.orGroup': 'or a group',
  'sched.when': 'When',
  'sched.weekly': 'Weekly',
  'sched.dates': 'Dates',
  'sched.days': 'Days of the week',
  'sched.date': 'Date',
  'sched.addDate': '+ Add date',
  'sched.from': 'From',
  'sched.to': 'to',
  'sched.action': 'What to do',
  'sched.kind.tour': 'Tour',
  'sched.kind.autonomy': 'Autonomy',
  'sched.kind.agent': 'Agent prompt',
  'sched.tour': 'Tour',
  'sched.pickTour': 'Pick a tour…',
  'sched.untilEnd': 'Repeat until the window ends',
  'sched.spread': 'Spread rounds over the window',
  'sched.spreadPreview': 'Rounds start at {times}',
  'sched.prompt': 'Prompt (one agent run at the window start)',
  'sched.promptPh': 'e.g. Greet the morning visitors in Uzbek and Russian, then go to the entrance.',
  'sched.batteryMin': 'Minimum battery',
  'sched.batteryHint': 'Below the minimum the robot goes to the charger and resumes at 80 % if the window is still open. Rounds are skipped (and logged) while a robot is offline, busy with a manual task or charging.',
  'sched.endAction': 'At the end of the window',
  'sched.history': 'History',
  'sched.noHistory': 'No runs yet.',
  'sched.liveEvent': '{event} · {ago}',
  'sched.runNow': 'Run now',
  'sched.runStarted': '“{name}” started',
  'sched.saveFirst': 'Save the changes first',
  'sched.save': 'Save schedule',
  'sched.savedShort': 'Saved',
  'sched.saved': 'Schedule “{name}” saved',
  'sched.saveFailed': 'Saving failed',
  'sched.deleteConfirm': 'Delete schedule “{name}”?',
  'sched.prevWeek': 'Previous week',
  'sched.nextWeek': 'Next week',
  'sched.thisWeek': 'This week',
  'sched.err.name': 'Give the schedule a name',
  'sched.err.targets': 'Pick robots or a group',
  'sched.err.days': 'Pick at least one day or date',
  'sched.err.window': 'The window must end after it starts',
  'sched.err.tour': 'Pick a tour',
  'sched.err.profile': 'Pick an autonomy profile',
  'sched.err.prompt': 'Write the agent prompt',

  'auto.title': 'Autonomy',
  'auto.pageTitle': 'Autonomy',
  'auto.pageSub': 'Profiles for robots that talk to visitors and guide them on their own',
  'auto.apiMissing': 'Autonomy is not available on this server yet (PROTOCOL §19 endpoints missing).',
  'auto.off': 'off',
  'auto.profile': 'Profile',
  'auto.profiles': 'Profiles',
  'auto.noProfiles': 'No profiles yet',
  'auto.newProfile': '+ New profile',
  'auto.pickHint': 'Pick a profile or create a new one.',
  'auto.start': 'Start autonomy',
  'auto.startShort': 'Autonomy…',
  'auto.stop': 'Stop autonomy',
  'auto.stopShort': 'Stop',
  'auto.overrideNote': 'Any manual control from the site (drive, stop, navigate…) pauses autonomy for 60 s; Stop ends it.',
  'auto.manageProfiles': 'Manage profiles',
  'auto.transcript': 'Live transcript',
  'auto.noTranscript': 'Nothing yet — visitor utterances, replies and tool calls appear here.',
  'auto.visitor': 'visitor',
  'auto.robot': 'robot',
  'auto.ended': 'autonomy ended',
  'auto.state.listening': 'listening',
  'auto.state.thinking': 'thinking',
  'auto.state.speaking': 'speaking',
  'auto.state.moving': 'moving',
  'auto.state.paused': 'paused',
  'auto.state.idle': 'idle',
  'auto.runningNow': 'Running now',
  'auto.name': 'Name',
  'auto.namePh': 'e.g. Museum guide',
  'auto.persona': 'Persona',
  'auto.personaPh': 'e.g. A friendly museum guide who speaks briefly and warmly.',
  'auto.instructions': 'Instructions',
  'auto.instructionsPh': 'Rules for the conversation: what to offer, what to avoid, when to guide people…',
  'auto.languages': 'Languages',
  'auto.defaultLang': 'Default language',
  'auto.pickMap': 'Pick a map…',
  'auto.homePoint': 'Home point',
  'auto.allowedPoints': 'Points the robot may guide to',
  'auto.allPoints': 'All points',
  'auto.noKnowledge': 'no description',
  'auto.pickMapFirst': 'Pick a map to choose points.',
  'auto.maxSpeed': 'Max speed',
  'auto.convTimeout': 'Conversation ends after',
  'auto.idle': 'When nobody talks',
  'auto.greetOnPresence': 'Greet people who come close',
  'auto.returnHome': 'Return to the home point after',
  'auto.tools': 'Allowed tools',
  'auto.toolsDefault': 'Default (all robot tools)',
  'auto.toolsHint': 'Driving and raw commands are never available to autonomy.',
  'auto.knowledge': 'Extra knowledge',
  'auto.knowledgeTitle': 'Knowledge',
  'auto.knowledgePh': 'Facts that are not tied to a point: opening hours, rules, directions…',
  'auto.save': 'Save profile',
  'auto.saved': 'Profile “{name}” saved',
  'auto.saveFailed': 'Saving failed',
  'auto.deleteConfirm': 'Delete profile “{name}”?',
  'auto.err.name': 'Give the profile a name',
  'auto.err.langs': 'Pick at least one language',
  'dayFull.mon': 'Monday',
  'dayFull.tue': 'Tuesday',
  'dayFull.wed': 'Wednesday',
  'dayFull.thu': 'Thursday',
  'dayFull.fri': 'Friday',
  'dayFull.sat': 'Saturday',
  'dayFull.sun': 'Sunday',
  'know.pointPanel': 'Point panel',
  'know.tabArrival': 'On arrival · {n}',
  'know.tabKnowledge': 'Knowledge',
  'know.coverage': '{n} described',
  'know.baseTitle': 'Used for every language unless a language tab has its own text',
  'know.descriptionSub': 'what the robot knows about this place',
  'know.overrideSub': 'replaces the main text in this language',
  'know.removeTalkingPoint': 'Remove talking point {n}',
  'know.min': 'min',
  'know.durationHint': 'how long to talk here before moving on',
  'know.attachmentsN': 'Attached documents · {n}',
  'know.detach': 'Detach {name}',
  'sched.colOn': 'On',
  'sched.colSchedule': 'Schedule · robots',
  'sched.colDays': 'Days',
  'sched.colWindow': 'Window',
  'sched.colAction': 'Action',
  'sched.colNext': 'Next run',
  'sched.off': 'Off',
  'sched.today': 'Today',
  'sched.todayAt': 'Today {time}',
  'sched.todayWord': 'Today',
  'sched.untilEndShort': 'until window end',
  'sched.pauseN': 'pause {n} min',
  'sched.editTitle': 'Edit schedule',
  'sched.newTitle': 'New schedule',
  'sched.discardConfirm': 'Discard unsaved changes to this schedule?',
  'sched.windowStart': 'Window start',
  'sched.windowEnd': 'Window end',
  'sched.useDates': 'Specific dates…',
  'sched.useWeekdays': 'Days of the week',
  'sched.roundsN': 'Number of rounds',
  'sched.roundsWord': 'rounds',
  'sched.spreadOff': 'Rounds run back to back with the pause between them.',
  'sched.pauseBetween': 'Pause between rounds',
  'sched.min': 'min',
  'auto.profilesN': 'Profiles · {n}',
  'auto.runningOnList': 'Running on {list}',
  'auto.notRunning': 'Not running',
  'auto.unsaved': 'Not saved yet',
  'auto.testOn': 'Test on…',
  'auto.started': 'Autonomy started on {name}',
  'auto.voice': 'Voice & behaviour',
  'auto.startIn': 'Start in',
  'auto.silenceN': '{n} s of silence',
  'auto.timeoutHint': 'then say goodbye and wait for the next visitor',
  'auto.pointKnowledge': 'Point knowledge',
  'auto.pointKnowledgeMeta': '{described} of {n} allowed points described',
  'auto.auto': 'auto',
  'auto.where': 'Where it may go',
  'auto.allowedPointsN': 'Allowed points · {n} of {of}',
  'auto.speedCap': 'Speed cap',
  'auto.toolsN': '{n} of {of} on',
  'auto.tool.say': 'Speak a reply',
  'auto.tool.perform_motion': 'Arm gestures (wave, guide…)',
  'auto.tool.show_emotion': 'Face expression on the screen',
  'auto.tool.set_head': 'Tilt the head to look at the visitor',
  'auto.tool.set_light': 'Chest light colour',
  'auto.tool.set_volume': 'Speaker volume',
  'auto.tool.go_to_point': 'Guide the visitor to an allowed point',
  'auto.tool.get_point_info': 'Read a point’s description (facts)',
  'auto.tool.start_presentation': 'Show a presentation on the screen',
  'auto.tool.play_media': 'Play a video / audio / image',
  'auto.tool.get_camera_snapshot': 'Look through the camera',
  'auto.tool.end_conversation': 'Say goodbye and end the conversation',
  'auto.tool.return_home': 'Go back to the home point',
  'auto.tool.dock': 'Go to the charger when the battery is low',
  'auto.unavailable': 'unavailable',
  'auto.showTools': 'Show tool calls',
  'auto.blocked': 'blocked',
  'auto.blockedN': '{n} blocked',
  'auto.session': 'Session',
  'auto.turns': 'Visitor turns',
  'auto.toolCalls': 'Tool calls',
  'auto.onScreenNow': 'On the robot screen now',
  'auto.stopped': 'Autonomy stopped',
  'auto.takeOver': 'Pause and take over manually',
  'auto.manualBanner': 'Autonomy is on — any manual command pauses it for 60 s.',
  'auto.backToTranscript': 'Back to transcript',
  'auto.mic': 'Microphone',
  'auto.micMode': 'Microphone mode',
  'auto.wakeLabel': 'Microphone',
  'auto.wake.default': 'Profile default',
  'auto.wake.always': 'Always listening',
  'auto.wake.hold': 'Hold to talk',
  'auto.wake.presence': 'When someone comes close',
  'auto.wake.button': 'Tap “Talk to me”',
  'auto.wakeHint.presence': 'Listens when a visitor is detected in front of the robot',
  'auto.wakeHint.always': 'The microphone is always open',
  'auto.wakeHint.button': 'Visitor taps “Talk to me” to start a conversation',
  'auto.wakeHint.hold': 'Visitor holds “Talk to me” while speaking; releasing sends',
  'auto.wakeApiMissing': 'Changing the microphone mode needs a newer server',
  'auto.typePlaceholder': 'Type as the visitor…',
  'auto.typeSend': 'Send',
  'auto.typeLang': 'Language of the typed message',
  'auto.typeApiMissing': 'Typing as the visitor needs a newer server',
  'auto.typedBy': 'typed by {by}',
  'auto.operator': 'operator',
  'auto.note': 'Internal note (not spoken)',
  'auto.jumpLatest': 'Jump to latest',
  'auto.interrupted': 'interrupted',
  'auto.interruptedTurn': 'Robot interrupted',
  'auto.unspoken': 'Not spoken — the visitor interrupted',
  'auto.bargeHint': 'Sending will interrupt the robot',
  'auto.bargeIn': 'Barge-in',
  'auto.bargeIn.voice': 'Voice (experimental)',
  'auto.bargeIn.button': 'Button & typed only',
  'auto.bargeIn.off': 'Off',
  'auto.bargeInHint.voice': 'Visitors can talk over the robot; the mic stays open while it speaks',
  'auto.bargeInHint.button': 'Holding “Talk to me” or typing interrupts the robot',
  'auto.bargeInHint.off': 'The robot finishes speaking before it listens (typed input still interrupts)',
  'reach.tight': "Too close to a wall — the robot will drive to the nearest reachable spot",
  'reach.unreachable': "Unreachable: enclosed by virtual walls / obstacles",
  'reach.status.ok': "Reachable",
  'reach.status.tight': "Too close to a wall",
  'reach.status.enclosed': "Enclosed by virtual walls",
  'reach.status.blocked': "Blocked by obstacles",
  'reach.countUnreachable': "{n} unreachable",
  'reach.countTight': "{n} near a wall",
  'reach.moveHere': "Move point here",
  'reach.clearance': "clearance {m} m",
  'reach.pending': "Reachability is checked after saving",
  'reach.approach': "Nearest reachable spot",
  'reach.noApproach': "No reachable spot nearby — move the point or edit the walls",
  'reach.warnUnreachable': "{n} point(s) unreachable",
  'reach.warnTight': "{n} point(s) too close to a wall",
  'reach.savedWarnings': "Saved with warnings: {s}",
  'stuck.phase.detected': "obstacle detected",
  'stuck.phase.announce': "asking to make room",
  'stuck.phase.lookaround': "looking around",
  'stuck.phase.replan': "trying another path",
  'stuck.phase.recovered': "way is clear",
  'stuck.phase.failed': "gave up",
  'stuck.banner': "Blocked — {phase} (attempt {a}/{m})",
  'stuck.failed': "Robot can’t get through — help needed",
  'stuck.failedAt': "at x {x} · y {y}",
  'stuck.goal': "heading to {goal}",
  'stuck.showOnMap': "Show on map",
  'stuck.dismiss': "Dismiss",
  'stuck.recoveredToast': "{name}: the way is clear, continuing",
  'stuck.failedToast': "{name} can’t get through — help needed",
  'stuck.openRobot': "Open robot",
  'stuck.chip': "Blocked {a}/{m}",
  'stuck.chipFailed': "Stuck — help",
  'stuck.line': "⚠ Blocked — {phase} ({a}/{m})",
  'stuck.lineRecovered': "✓ The way is clear",
  'stuck.lineFailed': "⛔ Can’t get through — gave up after {a} attempt(s)",
  'stuck.pointBadge': "stuck ×{n}",
  'stuck.pointBadgeTitle': "The robot recently got stuck {n} time(s) on the way to this point",
  'stuck.phase.detour': "going around",
  'stuck.phase.detour.left': "going around on the left",
  'stuck.phase.detour.right': "going around on the right",
  'charge.title': "Auto-charge",
  'charge.enabled': "Auto-charge enabled",
  'charge.low': "Go charge below",
  'charge.resume': "Resume at",
  'charge.critical': "Critical",
  'charge.criticalHint': "At this level the robot drops everything and goes to charge immediately",
  'charge.resumeTask': "Resume the task after charging",
  'charge.save': "Save auto-charge",
  'charge.saved': "Auto-charge settings saved",
  'charge.saveFailed': "Could not save auto-charge settings",
  'charge.apiMissing': "Auto-charge settings need a newer server",
  'charge.noCharger': "Map “{map}” has no ⚡ charger point — the robot will dock with the station directly, without a guided approach.",
  'charge.openMap': "Set it on the map",
  'charge.state.idle': "idle",
  'charge.state.going': "going to charge",
  'charge.state.charging': "charging",
  'charge.state.failed': "failed",
  'charge.lowToast': "Battery {b}% — going to charge",
  'charge.dockedToast': "docked, charging ({b}%)",
  'charge.failedToast': "Couldn’t reach the charger",
  'charge.resumedToast': "charged to {b}% — resuming the task",
  'charge.chip.going': "Going to charge",
  'charge.chip.charging': "Charging",
  'charge.chip.failed': "Charge failed",
  'charge.dockTitle': "Dock: drives to the ⚡ charger point of the current map when one is set, then connects to the station",
  'charge.dockTitleCharger': "Drives to the ⚡ charger point “{name}”, then connects to the station",
  'charge.dockTitleNoCharger': "No ⚡ charger point on this map — connects to the station directly",
  'charge.pointType': "Point type",
  'charge.kindNormal': "Normal",
  'charge.kindCharger': "Charger",
  'charge.kindTaken': "moves from another point",
  'charge.moveChargerConfirm': "“{from}” is already the ⚡ charger point (only one per map). Move the ⚡ to “{to}”?",
  'charge.placeHint': "Place the point ~0.5 m in front of the charging station, arrow pointing at the station",
  'charge.rotateHandle': "Drag to set the heading (Shift = free angle)",
  'auto.tabTranscript': "Transcript",
  'auto.tabControls': "Controls",
  'auto.liveControls': "Live controls",
  'auto.sessionNow': "This session",
  'auto.controlsNote': "Changes here don’t pause autonomy",
  'auto.maxSpeedSession': "Max speed",
  'auto.turnSpeed': "Turn speed",
  'auto.turnSpeedTip': "How fast the robot rotates. It turns in place, so there is no turning radius to set.",
  'auto.sessionLang': "Language",
  'auto.paramsApiMissing': "Changing this during autonomy needs a newer server",
  'auto.home.toPoint': "Returning to its spot ({point})",
  'auto.home.back': "Returning to its spot",
  'auto.home.idle': "no activity for {s} s",
  'auto.home.idleNoS': "no activity",
  'hand.button': "Hand push",
  'hand.title': "Release the wheel brakes so staff can push the robot",
  'hand.lock': "Lock wheels",
  'guard.title': "Robot guard",
  'guard.short': "Guard",
  'guard.off': "Guard off",
  'guard.turnOn': "Turn the guard on",
  'guard.turnOff': "Turn the guard off",
  'guard.distance': "Guard distance",
  'guard.distanceHint': "0.5–3.0 m: a spoken warning when crossed, the siren a second later",
  'guard.closer': "Closer",
  'guard.farther': "Farther",
  'guard.pause': "Pause 15 min",
  'guard.resume': "Resume",
  'guard.reset': "Reset to 1.5 m",
  'guard.hint': "Applies at once; every change is journaled on the robot.",
  'guard.lidarOk': "lidar ok",
  'guard.lidarNo': "no lidar data",
  'guard.ros': "ROS connected",
  'guard.rosDown': "ROS not connected",
  'guard.state.watching': "Watching",
  'guard.state.learning': "learning the surroundings",
  'guard.state.moving': "Moving — lidar waits, arm touch still watched",
  'guard.state.warn': "Warning",
  'guard.state.alarm': "ALARM",
  'guard.state.touch': "Arm touched",
  'guard.state.paused': "Paused until {until}",
  'guard.state.blind': "Does not see (no lidar data)",
  'guard.fail': "Guard · {name}: {why}",
  'guard.failSilent': "Guard · {name} did not respond",
  'guard.whyUnsupported': "the robot app has no guard — update the APK",
  'hand.lockTitle': "Re-engage the wheel brakes",
  'hand.banner': "Hand push mode — wheels released.",
  'hand.driveHint': "Hand push mode is on — driving is disabled until the wheels are locked. STOP also locks them.",
  'hand.blocked': "hand push mode is on — lock the wheels first",
  'charge.addCharger': "Add charger point",
  'charge.chargerIs': "Charger:",
  'charge.edit': "Edit",
  'charge.newName': "Charger",
  'charge.clickHint': "Click on the map ~0.5 m in front of the charging station, then turn the arrow towards the station",
  'charge.dockTitleMany': "Drives to the nearest free ⚡ charger ({n} on this map), then connects to the station",
  'charge.occ.free': "free",
  'charge.occ.occupied': "occupied",
  'charge.occ.occupiedBy': "occupied: {name}",
  'charge.occ.reserved': "reserved",
  'charge.occ.reservedBy': "reserved: {name}",
  'charge.occ.unknown': "state unknown",
  'charge.occ.thisRobot': "this robot",
  'charge.countOnMap': "Chargers on the map: {n}",
  'charge.showOnMap': "Show on map",
  'charge.chooseCharger': "Choose a charger",
  'charge.nearestFree': "Nearest free",
  'charge.dockNearest': "Charge · nearest free",
  'charge.noChargersShort': "No ⚡ charger points on this map",
  'charge.chargersTitle': "Chargers",
  'charge.allBusy': "All chargers are busy — try again later",
  'charge.dockFailed': "Couldn’t dock (stage: {stage})",
  'charge.dockTried': "tried: {list}",
  'sens.ageMin': "{m} min ago",
  'sens.ageNow': "{s} s ago",
  'sens.ageS': "{s} s ago",
  'sens.alApproach': "Something approaching",
  'sens.alApproachDesc': "{id} · {d} {side} · {v} m/s · contact in ≈{ttc} s",
  'sens.alCliff': "Cliff detected · drive blocked",
  'sens.alCliffDesc': "SDK cliff event (yes/no, no position) · robot stopped by ROS",
  'sens.alEstop': "Emergency stop pressed",
  'sens.alEstopDesc': "Release the button on the robot’s back to drive again",
  'sens.alInside': "Approach alert · inside {d}",
  'sens.alNone': "No alerts",
  'sens.alNoneDesc': "Nothing approaching inside {d}",
  'sens.alObstacle': "SDK obstacle event",
  'sens.alObstacleDesc': "Navigation reports an obstacle ahead · motion paused by ROS",
  'sens.alSectorNd': "Depth sector {n} · no data",
  'sens.alSectorNdDesc': "The sector returns 0 · likely glare or out of range",
  'sens.alSkin': "E-skin touched · {z}",
  'sens.alSkinDesc': "Someone is touching the robot’s arm",
  'sens.alTooClose': "Too close",
  'sens.alTooCloseDesc': "Something is {d} in front of the robot",
  'sens.alertAt': "Approach alert at <",
  'sens.alerts': "Alerts",
  'sens.blindRear': "no distance data (robot navigation only)",
  'sens.blindSide': "no distance data",
  'sens.camSoonTitle': "Camera people — coming soon (no camera detections on the server yet)",
  'sens.capCharging': "Charging · sensors idle",
  'sens.capCliff': "Cliff · drive blocked",
  'sens.capNoSensors': "No sensor data",
  'sens.capStale': "Depth data stale",
  'sens.capSummary': "{n} approaching · nearest {d}",
  'sens.chargingDesc': "Tracks paused · depth summary still arrives at ~1 Hz",
  'sens.chipClear': "Clear",
  'sens.chipNoData': "No data",
  'sens.clear': "clear",
  'sens.clearBeyond': "clear beyond",
  'sens.cliff': "Cliff",
  'sens.cliffBadge': "Cliff · no position from SDK",
  'sens.colBearing': "Bearing",
  'sens.colDist': "Dist",
  'sens.colHistory': "60 s",
  'sens.colRaw': "Raw",
  'sens.colSector': "Sector",
  'sens.colTrend': "Trend",
  'sens.depthOnly': "depth",
  'sens.details': "Sensor details",
  'sens.eskin': "E-skin",
  'sens.estop': "E-stop",
  'sens.frontLabel': "FRONT · waist depth fan 72°",
  'sens.idleShort': "idle",
  'lidar.layer': 'Lidar 360°',
  'lidar.layerTitle': "Show what the robot's lidar sees, live (walls as dots, moving objects with a trail)",
  'lidar.max': "Max",
  'lidar.maxTitle': "Fit the farthest point the lidar sees",
  'lidar.zoomIn': "Closer",
  'lidar.zoomOut': "Farther",
  'lidar.zoomHint': "Scroll over the radar to zoom",
  'lidar.range': 'Range',
  'lidar.badge.live': 'LIVE {hz}',
  'lidar.badge.off': 'switched off',
  'lidar.badge.connecting': 'connecting…',
  'lidar.badge.nodata': 'no data',
  'lidar.badge.moving': 'robot driving',
  'lidar.card': 'Lidar live',
  'lidar.switchTitle': "Stream this robot's lidar to the site",
  'lidar.cardNote': 'The robot sends what its lidar sees only while this switch is on and someone has the radar open. Turning it off stops the stream for everyone on this robot.',
  'lidar.rate': 'Rate',
  'lidar.delay': 'Delay',
  'lidar.watching': 'Watching',
  'lidar.status.off': 'Switched off: nothing is sent; the radar shows only the other layers.',
  'lidar.status.connecting': 'Waiting for the first scan…',
  'lidar.status.live': 'Walls as dots, moving objects as coloured dots with a trail.',
  'lidar.status.moving': 'The robot is driving: walls only, moving objects are found while it stands.',
  'lidar.status.nodata': 'No lidar data: the robot is offline, its app is too old, or the lidar is silent.',
  'lidar.moving': 'Moving objects',
  'lidar.movingNote': '{n} · lidar',
  'lidar.colMotion': 'Motion',
  'lidar.approaching': 'approaching',
  'lidar.receding': 'moving away',
  'lidar.stopped': 'stopped {s} s',
  'lidar.noObjects': 'Nothing moves around the robot.',
  'lidar.caption': "Lidar · nearest {d}",
  'lidar.captionNone': "Lidar · nothing seen",
  'lidar.lgPoints': 'lidar points (walls, furniture)',
  'lidar.lgTrail': 'trail, last 2 s',
  'lidar.toggle': 'Lidar',
  'lidar.toggleTitle': 'Lidar on the mini-radar',
  'site.label': "Site",
  'site.tabs': "Sites",
  'site.robotSite': "Robot's site",
  'site.none': "No site",
  'site.noneShort': "No site",
  'site.manage': "Manage sites…",
  'site.manageShort': "Sites…",
  'site.change': "Change the robot's site",
  'site.moveTo': "Move to a site…",
  'site.moved': "{n} robot(s) → {site}",
  'site.movedNone': "{n} robot(s) without a site now",
  'site.title': "Sites",
  'site.oneSiteNote': "A robot is always at one site. Tablets limited to a site (Admin → Kiosk accounts) list only its robots.",
  'site.name': "Name",
  'site.color': "Colour",
  'site.robotsN': "{n} robots",
  'site.edit': "Edit {name}",
  'site.delete': "Delete {name}",
  'site.deleteConfirm': "Delete the site “{name}”? Its {n} robot(s) stay, without a site.",
  'site.empty': "No sites yet.",
  'site.new': "New site",
  'site.newPlaceholder': "e.g. Samarkand",
  'site.add': "Add",
  'site.allGroups': "All groups",
  'site.sectionCount': "{n} robots",
  'site.sectionOnline': "{n} online",
  'site.onlyThis': "Only {site}",
  'site.allFrom': "All from “{site}” · {n}",
  'guard.barrier': "Alarm at {d}",
  'guard.barrierOff': "guard off",
  'guard.lgBarrier': "guard alarm border (from the body)",
  'sens.lCamera': "Camera people",
  'sens.lDepth': "Depth fan",
  'sens.lPresence': "Presence",
  'sens.lTracks': "Tracks",
  'sens.layers': "Layers",
  'sens.lblApproach': "↓ approaching {v} m/s · {ttc} s",
  'sens.lblAway': "↑ moving away {v} m/s",
  'sens.lblStatic': "· static",
  'sens.legend': "Legend",
  'sens.lgAlertRing': "alert ring",
  'sens.lgHuman': "human_detect 1.3 m (no direction)",
  'sens.lgNoData': "no distance data",
  'sens.no': "no",
  'sens.noDirection': "no direction",
  'sens.noPose': "no pose",
  'sens.noSensorsDesc': "The robot does not report status.sensors (older app or emulator)",
  'sens.noTracks': "Nothing confident in front",
  'sens.noTracksStale': "No fresh depth data",
  'sens.object': "Object",
  'sens.obstacle': "Obstacle",
  'sens.onChange': "on change",
  'sens.onEvent': "on event",
  'sens.options': "Radar options",
  'sens.pressed': "PRESSED",
  'sens.radar': "Proximity radar",
  'sens.released': "released",
  'sens.robotViews': "Robot views",
  'sens.safetyEvents': "Safety events",
  'sens.sectorsNote': "Raw values in cm as sent by the robot (coarse, flicker between frames). A sector counts only when 3 of the last 5 agree; faded = low confidence. ≥ 95 cm = far. Rear and sides: no distance data (robot navigation only).",
  'sens.sectorsTitle': "Front depth · 6 sectors",
  'sens.sideF': "front",
  'sens.sideL': "front-left",
  'sens.sideR': "front-right",
  'sens.sources': "Live sources",
  'sens.srcCliff': "Cliff (yes/no) · {s}",
  'sens.srcDepth': "Depth summary · coarse (~15 cm steps), 1 Hz",
  'sens.srcHuman': "Presence ≤ 1.3 m · {s} · no direction",
  'sens.srcObstacle': "Obstacle (ROS) · {s}",
  'sens.srcSkin': "Arm touch zones · {n} touched",
  'sens.staleDesc': "Last depth reading {age} · fan hatched, no tracking",
  'sens.tabDrive': "Drive",
  'sens.tabSensors': "Sensors",
  'sens.toolbarNote': "front fan only · trend from 1 Hz readings",
  'sens.tracked': "Tracked objects",
  'sens.trackedNote': "{n} · depth + camera",
  'sens.trend.approaching': "↓ closer",
  'sens.trend.receding': "↑ away",
  'sens.trend.static': "· static",
  'sens.units': "Units",
  'sens.yes': "YES",
  'sens.yesAhead': "YES · ahead",
  'sens.state.normal': "Clear in front",
  'sens.state.approaching': "Someone approaching",
  'sens.state.tooClose': "Too close",
  'sens.state.cliff': "Cliff detected",
  'sens.state.nodata': "No sensor data",
  'sens.state.charging': "Charging · sensors idle",
  'sens.radarToggle': "Radar",
  'sens.radarToggleTitle': "Show the proximity mini-radar over the camera",
  'sens.openSensors': "Open the Sensors page",
  'maps.layerSensors': "Sensors",
  'sens.lgClear': "≥ {d} = clear",
  'sens.colRawFiltered': "Raw | filt.",
  'sens.rawFilteredTitle': "Latest raw reading | filtered value (cm): median of the last 5 that agree",
  'sens.chipNoisy': "Noisy",
  'sens.chipLow': "Low conf.",
  'sens.far': "far",
  'cal.title': "Sensor calibration",
  'cal.button': "Calibration",
  'cal.notCalibrated': "not calibrated",
  'cal.steps': "Steps",
  'cal.short.empty': "Empty space",
  'cal.short.centre': "0.5 m centre",
  'cal.short.left': "0.5 m left",
  'cal.short.right': "0.5 m right",
  'cal.step.empty': "Clear the space in front of the robot: nothing within 1.5 m (people step aside). Then record 10 s. Values that flicker in empty space are learned as noise for each sector.",
  'cal.step.centre': "Stand (or put a box) 0.5 m in front of the robot, in the centre. Keep still and record 10 s.",
  'cal.step.left': "Now 0.5 m in front, at the far LEFT edge of the robot’s view (the robot’s left). Record 10 s.",
  'cal.step.right': "Now 0.5 m in front, at the far RIGHT edge (the robot’s right). Record 10 s.",
  'cal.passive': "The robot does not move; this only records the depth data it already sends.",
  'cal.recording': "Recording… {s} s · {n} frames",
  'cal.got': "{n} frames recorded · share of “near” readings per sector:",
  'cal.nearShare': "Near readings per sector",
  'cal.tooFew': "Too few frames; check that the robot sends depth data and record again.",
  'cal.noData': "No fresh depth data from the robot.",
  'cal.back': "Back",
  'cal.start': "Record 10 s",
  'cal.redo': "Record again",
  'cal.next': "Next",
  'cal.finish': "Finish",
  'cal.order': "Sector order",
  'cal.ltr': "left → right",
  'cal.rtl': "right → left (reversed)",
  'cal.unclear': "unclear (kept the default)",
  'cal.scale': "Distance scale",
  'cal.noise': "Empty-space noise per sector",
  'cal.ignoreNote': "Flicker values (need 4 of 5 to count): {list}",
  'cal.again': "Start over",
  'cal.save': "Save calibration",
  'cal.savedServer': "Calibration saved for this robot",
  'cal.savedLocal': "Calibration saved in this browser (the server does not store it yet)",
  'cal.current': "Current: {at} · order {order} · scale ×{scale}",
  'cal.resetBtn': "Reset",
  'cal.resetConfirm': "Remove this robot’s sensor calibration?",
  'cal.reset': "Calibration removed",
  'sens.person': "Person",
  'sens.src.depth': "depth",
  'sens.src.camera': "camera",
  'sens.src.fused': "camera + depth",
  'sens.capPeople': "{p} people · {n} approaching · nearest {d}",
  'sens.camLayerTitle': "Faces from the head camera (frontal, ~0.4–2.5 m) and the camera field of view",
  'sens.camHint': "Camera people work while the robot’s camera is open",
  'sens.camOffTitle': "Camera people: off",
  'sens.camOpen': "Open camera",
  'sens.camWatching': "Camera open",
  'sens.colSource': "Source",
  'sens.srcPeople': "Head camera faces · {n} now · FOV {fov}°",
  'sens.srcPeopleOff': "Head camera faces · off (camera not open)",
  'cal.short.camera': "Camera 1 m (optional)",
  'cal.step.camera': "Optional: stand 1 m in front of the robot, about 30 cm to the ROBOT’S LEFT, facing it (the camera sees faces). Record 10 s. This checks the camera distance scale and whether left/right is mirrored.",
  'cal.camNoSupport': "This robot does not report camera people (older app).",
  'cal.camStarting': "Opening the camera… people detection starts once the robot publishes it.",
  'cal.camGot': "{n} frames with a face · median {d} m at {b}° (+ = left)",
  'cal.camTooFew': "Only {n} frames with a face; face the robot and record again.",
  'cal.skip': "Skip",
  'cal.camera': "Camera",
  'cal.camSkipped': "not checked",
  'cal.camScale': "distance × {s}",
  'cal.mirrorYes': "left/right MIRRORED",
  'cal.mirrorNo': "left/right OK",
  'cal.mirrorUnclear': "mirroring unclear (stand more to the left)",
  'cal.pushMirror': "Also tell the robot (cameraMirrored), so its own bearings are fixed",
  'cal.mirrorNotSupported': "The server doesn’t accept cameraMirrored yet; mirroring is corrected in this console only.",
  'mode.normal': "Normal",
  'mode.estop': "Emergency stop",
  'mode.estopHint': "Release the red button on the robot’s back",
  'mode.handPush': "Hand push",
  'mode.stuck': "Stuck",
  'mode.stuckFailed': "Stuck · needs help",
  'mode.charging': "Charging",
  'mode.goingCharge': "Going to charge",
  'mode.chargeFailed': "Couldn’t reach the charger",
  'mode.autonomy': "Autonomy",
  'mode.tour': "Tour",
  'mode.navigation': "Navigation",
  'mode.navTo': "Navigation → {point}",
  'mode.task': "Task: {task}",
  'mode.lockShort': "Lock wheels",
  'mode.exitHandPush': "Exit hand push: lock the wheels again",
  'mode.stopShort': "Stop",
  'mode.stopTitle': "Stop the current task",
  'hand.whyUnsupported': "the robot app does not support it yet",
  'hand.whyEstop': "the emergency stop is pressed",
  'hand.whyCharging': "the robot is on the charger",
  'hand.whyUnknown': "unknown error",
  'hand.failReleaseSilent': "Couldn’t release wheels · {name} did not respond",
  'hand.failLockSilent': "Couldn’t lock wheels · {name} did not respond — press STOP or the robot’s emergency button",
  'hand.failRelease': "Couldn’t release wheels · {name}: {why}",
  'hand.failLock': "Couldn’t lock wheels · {name}: {why} — press STOP or the robot’s emergency button",
  'mapRobots.chipCharging': "on charger",
  'mapRobots.chipOtherMap': "map {name}",
  'mapRobots.notLocatedHint': "the robot does not know where it is on this map",
  'mapRobots.toggle': "Show / hide details",
  'facing.unset': "facing direction not set",
  'facing.unsetShort': "no direction",
  'facing.unsetHint': "the robot will arrive facing a random way; drag the arrow, type degrees or use “Look at…”",
  'facing.count': "{n} without direction",
  'facing.look': "Look at…",
  'facing.lookTitle': "Then click on the map where the person or exhibit is: the point will face that spot",
  'facing.lookHint': "Click on the map where “{name}” should look",
  'facing.flipTitle': "Turn around 180° (the charger point: Cruzr docks backwards, contacts at the rear)",
  'facing.warn': "{n} point(s) without a facing direction",
  'hist.title': "Autonomy history",
  'hist.tabProfiles': "Profiles",
  'hist.tabHistory': "History",
  'hist.link': "Conversation history",
  'hist.linkTitle': "Browse past autonomy conversations of this robot",
  'hist.countN': "{n} conversations",
  'hist.search': "Search in conversations…",
  'hist.robot': "Robot",
  'hist.profile': "Profile",
  'hist.allRobots': "All robots",
  'hist.allProfiles': "All profiles",
  'hist.from': "from",
  'hist.to': "to",
  'hist.clearFilters': "Clear filters",
  'hist.colWhen': "When",
  'hist.colRobot': "Robot",
  'hist.colProfile': "Profile",
  'hist.colDuration': "Duration",
  'hist.colTurns': "Turns",
  'hist.colTools': "Tools",
  'hist.colEnd': "End",
  'hist.colPreview': "First utterance",
  'hist.live': "live",
  'hist.end.stopped': "stopped by operator",
  'hist.end.timeout': "silence timeout",
  'hist.end.battery': "low battery",
  'hist.end.ended': "ended",
  'hist.end.estop': "emergency stop",
  'hist.end.schedule': "schedule window ended",
  'hist.end.error': "error",
  'hist.apiMissing': "Conversation history needs a newer server",
  'hist.empty': "No conversations match",
  'hist.more': "Load more",
  'hist.session': "Conversation",
  'hist.turnsN': "{n} turns",
  'hist.toolsN': "{n} tool calls",
  'hist.jump': "Jump to",
  'hist.go': "Go",
  'hist.loadEarlier': "Load earlier messages",
  'hist.exportFailed': "Export failed",
  'hist.deleteConfirm': "Delete this conversation permanently?",
  'hist.deleted': "Conversation deleted",
  'hist.deleteFailed': "Could not delete the conversation",
  'hist.deleteLive': "A running conversation cannot be deleted",
  'clog.logs': "Logs",
  'clog.tab.events': "Events",
  'clog.tab.cmd': "Command log",
  'clog.tab.app': "Robot app log",
  'clog.kind': "Kind",
  'clog.all': "All",
  'clog.cmds': "Commands",
  'clog.events': "Events",
  'clog.nameFilter': "Filter by name…",
  'clog.rowsN': "{n} rows",
  'clog.refresh': "Refresh",
  'clog.load': "Load",
  'clog.colTime': "Time",
  'clog.colName': "Command / event",
  'clog.colSource': "Source",
  'clog.colResult': "Result",
  'clog.colDuration': "Duration",
  'clog.colArgs': "Args / data",
  'clog.error': "error",
  'clog.args': "Arguments",
  'clog.data': "Data",
  'clog.apiMissing': "This log needs a newer server",
  'clog.empty': "No rows",
  'clog.grep': "grep…",
  'clog.lines': "Lines",
  'clog.noLines': "(no matching lines)",
  'clog.appHint': "The robot app’s log tail. Press Load: the server asks the robot for it.",
  'pull.online': "online",
  'pull.offlineShort': "offline",
  'pull.offline': "The robot is offline",
  'pull.robotOffline': "{robot} is offline: maps can be listed only from an online robot",
  'pull.pickRobot': "Choose an online robot",
  'pull.listing': "listing…",
  'pull.listingOn': "Listing maps on {robot}… navigation first, then U-SCAN",
  'pull.countOn': "{n} on {robot}",
  'pull.refresh': "Refresh the list of maps",
  'pull.retry': "Retry",
  'pull.secSdk': "Navigation (SDK)",
  'pull.scanningApp': "scanning app",
  'pull.mapsOne': "{n} map",
  'pull.mapsN': "{n} maps",
  'pull.noSdk': "No navigation maps on this robot",
  'pull.noUscan': "No U-SCAN maps on this robot",
  'pull.noUscanHint': "Scan an area in the U-SCAN app on the robot, then refresh this list.",
  'pull.uscanError': "U-SCAN maps could not be read: {error}",
  'pull.onServer': "already on server",
  'pull.modified': "modified {when}",
  'pull.today': "today, {time}",
  'pull.hint': "U-SCAN maps come from the robot’s scanning app; pulling converts them to a navigation map",
  'pull.waiting': "Waiting for the robot",
  'pull.selectOne': "Select a map to pull",
  'pull.converts': "Converts “{name}” to a navigation map",
  'pull.replaces': "Replaces the server copy of “{name}”",
  'pull.copies': "Copies “{name}” to the server",
  'pull.pullingName': "Pulling “{name}”…",
  'pull.stage.asking': "Asking the robot…",
  'pull.stage.downloading': "Collecting the map on the robot",
  'pull.stage.uploading': "Uploading to the server",
  'pull.stage.working': "Working…",
  'pull.mbOf': "{a} of {b} MB",
  'pull.mb': "{a} MB",
  'pull.keepOpen': "Large scans take a few minutes over Wi-Fi; keep this window open.",
  'hand.retry': "Retry",
  'fab.releasing': "Releasing wheels · {name}",
  'fab.locking': "Locking wheels · {name}",
  'fab.releasingShort': "Releasing wheels…",
  'fab.lockingShort': "Locking wheels…",
  'fab.chargingShort': "Hand push · charging",
  'fab.offlineShort': "Hand push · offline",
  'fab.offline': "Hand push · robot is offline",
  'fab.charging': "Hand push · robot is charging",
  'fab.lockName': "Lock wheels · {name}",
  'fab.handPushName': "Hand push · {name}",
  'fab.lockN': "Lock wheels · {n} robots",
  'fab.summaryOne': "{n} robot in hand push",
  'fab.summaryN': "{n} robots in hand push",
  'fab.popHint': "Releases the wheel brakes so staff can push the robot by hand. Switch it off to lock the wheels again.",
  'fab.noneOnline': "No robots online",
  'fab.lockAll': "Lock all wheels",
  'fab.chipReleasing': "Releasing…",
  'fab.chipLocking': "Locking…",
  'fab.chipIdle': "Idle",
  'fab.chipEstop': "E-stop",
  'fab.switchFor': "Hand push for {name}",
  'fab.wheelsReleased': "Wheels released",
  'tokens.manage': 'API tokens…',
  'tokens.title': 'API tokens',
  'tokens.hint': 'Personal tokens for MCP clients and scripts (REST: Authorization: Token <t>; MCP: Bearer <t>). A token is shown once.',
  'tokens.apiMissing': 'Token management is not available on this server.',
  'tokens.labelPlaceholder': 'Label, e.g. “Claude Desktop — laptop”',
  'tokens.create': 'Create token',
  'tokens.shownOnce': 'Token “{label}” — copy it now, it will not be shown again:',
  'tokens.copy': 'Copy',
  'tokens.copied': 'Copied',
  'tokens.revoke': 'Revoke',
  'tokens.revokeConfirm': 'Revoke token “{label}”? Clients using it stop working.',
  'tokens.none': 'No tokens yet.',
  'tokens.created': 'created {ago}',
  'tokens.used': 'used {ago}',
  // bulk "move near-wall points to their recommended spots" (Points tab)
  'bulk.hintTitle': '{n} point(s) too close to a wall',
  'bulk.hintText': "The robot can't stop exactly on such a point and stops nearby. Move them to the recommended spots — {m} m from the wall.",
  'bulk.hintButton': 'Move all to recommended spots…',
  'bulk.hintHide': 'Hide this hint',
  'bulk.linkTitle': 'Move to recommended spots',
  'bulk.pointLink': 'Move all such points ({n})…',
  'bulk.toastAction': 'Move {n}',
  'bulk.back': 'Points',
  'bulk.title': 'Move points away from walls',
  'bulk.text': 'Each point moves to the nearest spot at least {m} m from walls — the robot drives there and stops exactly on it. A point never moves more than 1 m or through a wall.',
  'bulk.selected': '{on} of {all} selected',
  'bulk.shift': 'shift {a}–{b} m',
  'bulk.turn': 'Turn to the old spot — the exhibit',
  'bulk.turnHint': 'Only points without a direction ({n}). A direction that is already set stays.',
  'bulk.all': 'All',
  'bulk.sortHint': 'by shift ↓ · click to show on the map',
  'bulk.row': 'clearance {c} m → shift {s} m',
  'bulk.rowAria': 'Move {n} · {name}',
  'bulk.enclosedNote': "Points behind virtual walls can't be fixed this way — see the Reachability tab.",
  'bulk.cancel': 'Cancel',
  'bulk.apply': 'Move and save · {n}',
  'bulk.empty': 'No points near walls',
  'bulk.previewChip': 'Preview — points are still in their old places',
  'bulk.legend': 'Legend',
  'bulk.legendNow': 'Point now — too close to a wall',
  'bulk.legendSpot': 'Recommended spot ({m} m from the wall)',
  'bulk.legendFace': 'Where the robot will face (the old spot)',
  'bulk.doneTitle': '{n} point(s) moved and saved',
  'bulk.doneAllOk': 'All points are reachable.',
  'bulk.doneLeft': '{n} still near a wall.',
  'bulk.doneFacing': 'Each one faces its old spot — the exhibit.',
  'bulk.undo': 'Put them back',
  'bulk.hide': 'Hide',
  'bulk.doneToast': 'Moved and saved: {n} point(s)',
  'bulk.toastUndo': 'Undo',
  'bulk.undone': 'Moved {n} point(s) back',
  'bulk.undoSkipped': 'Left alone (you changed them since): {k}',
  'maps.allPoints': 'All points',
  'maps.pointPos': '{i} of {n}',
  'maps.prevPoint': 'Previous point',
  'maps.nextPoint': 'Next point',
  'maps.filterAll': 'All · {n}',
  'maps.filterLabel': 'Filter points',
  'charge.addShort': 'Charger',
  'tours.allTours': 'All tours',
  'tours.tabStops': 'Stops · {n}',
  'tours.tabSettings': 'Settings',
  'tours.tabRobots': 'Robots · {n}',
  'tours.findStop': 'Find a stop',
  'tours.addStopShort': '+ Stop',
  'tours.noStops': 'No stops yet: add points with “+ Stop”.',
  'tours.stopSettings': 'Stop settings: {name}',
  'tours.toursCount': '{n} on this map',
  'facing.bulkTitle': 'Set a direction for all {n} points without one',
  'facing.bulkPresets': 'Quick directions',
  'facing.bulkHint': 'Points that already have a direction are not changed. Shown on the map right away; saved with “Save points”.',
  'facing.bulkApply': 'Turn {n} points',
  'facing.bulkDone': '{n} points now face {deg}°. Save the points to keep it.',
  'nav.updates': 'Updates',
  'upd.title': 'Robot app updates',
  'upd.auto': 'Robot auto-update',
  'upd.new': 'New version',
  'upd.drop': 'Drop the robot APK here',
  'upd.choose': 'Choose file',
  'upd.other': 'Another file',
  'upd.uploading': 'Uploading and checking… {pct}%',
  'upd.checked': '{size} · checked',
  'upd.version': 'Version',
  'upd.codeOf': 'code {code} (robots have {fleet})',
  'upd.signature': 'Signature',
  'upd.sigSame': 'matches the installed app',
  'upd.sigUnknown': 'not checked',
  'upd.notes': 'What\'s new (shown in the version list)',
  'upd.to': 'Who',
  'upd.toAll': 'All robots · {n}',
  'upd.toSite': 'Site',
  'upd.toRobots': 'Choose robots…',
  'upd.toRobotsN': 'Robots · {n}',
  'upd.pickTitle': 'Choose robots',
  'upd.done': 'Done',
  'upd.idleOnly': 'Only when idle',
  'upd.idleOnlyHint': '— not during a tour, a drive, a guard alarm or a conversation',
  'upd.canary': 'First one robot',
  'upd.canaryHint': 'the rest after it came back with the new version',
  'upd.publish': 'Publish {v}',
  'upd.published': 'Version {v} is published',
  'upd.versions': 'Versions',
  'upd.noVersions': 'No uploaded versions yet',
  'upd.onRobots': 'on {n} robots',
  'upd.rollingOut': 'rolling out · {done}/{total}',
  'upd.notPublished': 'not published',
  'upd.delete': 'Delete',
  'upd.deleteConfirm': 'Delete version {v}?',
  'upd.rollout': 'Rollout {v}',
  'upd.progress': '{done} of {total} updated',
  'upd.progressTap': '{n} waiting for a tap',
  'upd.pause': 'Pause rollout',
  'upd.resume': 'Resume rollout',
  'upd.pausedTag': 'paused',
  'upd.noRollout': 'Nothing is being rolled out. Upload an APK and press «Publish».',
  'upd.fAll': 'All · {n}',
  'upd.fIdle': 'Waiting for idle · {n}',
  'upd.fTap': 'Waiting for a tap · {n}',
  'upd.fProblems': 'Problems · {n}',
  'upd.fOffline': 'Offline · {n}',
  'upd.colRobot': 'Robot',
  'upd.colSite': 'Site',
  'upd.colVersion': 'Version',
  'upd.colState': 'State',
  'upd.s.done': 'Updated',
  'upd.s.canary': 'trial robot',
  'upd.s.offline': 'Offline · updates when it connects',
  'upd.s.manual': 'Old app without auto-update',
  'upd.s.manualHint': 'install this version by hand once',
  'upd.s.paused': 'Rollout paused',
  'upd.s.waiting_canary': 'Waits for the trial robot',
  'upd.s.pending': 'Offer sent',
  'upd.s.downloading': 'Downloading',
  'upd.s.failed': 'Error',
  'upd.s.unknown_sources': 'Unknown sources are off',
  'upd.s.unknownHint': 'once: Settings → Security → turn on',
  'upd.s.waiting_idle': 'Waiting for idle',
  'upd.s.snoozed': 'Downloaded · «Later» was pressed',
  'upd.s.prompt': 'Waiting for a tap on the robot',
  'upd.s.promptAt': '«Install» card shown at {time}',
  'upd.s.installer': 'Android installer is open',
  'upd.s.installerHint': 'press «Install» there',
  'upd.busy.tour': 'tour «{name}» · stop {step} of {total}',
  'upd.busy.tourShort': 'a tour is running',
  'upd.busy.moving': 'the robot is moving',
  'upd.busy.talking': 'talking to a visitor',
  'upd.busy.media': 'showing media',
  'upd.busy.guard': 'guard alarm',
  'upd.showNow': 'Show now',
  'upd.showAgain': 'Show again',
  'upd.retry': 'Retry',
  'upd.footer': 'Robots learn about a release at once and download it themselves, checking the checksum. A person confirms the install on the robot screen: «Install», then «Install» in Android\'s window. An older version can come back only as a build with a higher version code.',
  'upd.err.NOT_APK': 'Not an APK',
  'upd.err.NOT_APKHint': 'The file has no AndroidManifest.xml.',
  'upd.err.NOT_NEWER': 'Version is not newer',
  'upd.err.NOT_NEWERHint': 'The file has code {code}, robots already have {fleet}. Raise versionCode and rebuild.',
  'upd.err.CERT_MISMATCH': 'Different signature',
  'upd.err.CERT_MISMATCHHint': 'Android will not install this file over the installed app. Build with the same key as the previous versions.',
  'upd.err.WRONG_PACKAGE': 'Not the robot app',
  'upd.err.WRONG_PACKAGEHint': 'This is {package}. Need {expected}.',
  'upd.chip.version': 'App {v}',
  'upd.chip.available': '{v} available',
  'upd.chip.downloading': 'Downloading {pct}%',
  'upd.chip.waitingIdle': 'Waiting for idle',
  'upd.chip.tap': 'Waiting for a tap on the robot',
  'upd.chip.unknownSources': 'Unknown sources off',
  'upd.chip.failed': 'Update error',
} as const;

export type Dict = { [K in keyof typeof en]: string };
